export class TextToImageBuilder {
    constructor() {
        this.textureCanvas = null;
        this.textTexture = null;
    }

    dispose() {
        //dispose texture
        if (this.textTexture !== null) {
            this.textTexture.dispose();
            this.textTexture = null;
        }

        //remove canvas
        if (this.textureCanvas !== null) {
            this.textureCanvas.parentNode.removeChild(this.textureCanvas);
        }
    }


    /**
     * @param textAttributeValue
     * @param canvasHeigth
     * @param canvasWidthRatio
     * @param padding The padding is actually ignored at this stage.
     * @param position
     * @returns {null}
     */
    buildTexture(textAttributeValue, canvasHeigth, canvasWidthRatio, padding, position) {
        let renderText = textAttributeValue + ''
        let font = 'Abel'
        let fontScale = 24

        //check if it contains size
        let sizeIndex = renderText.lastIndexOf(' @size:')
        if (sizeIndex >= 0) {//we have size
            let sizeContainer = renderText.substr(sizeIndex + 1)
            var sizeRegex = /@size:(\d\.?\d*)/i
            let sizeMatch = sizeContainer.match(sizeRegex)
            if (sizeMatch.length === 2) {
                fontScale = parseFloat(sizeMatch[1])
            }
            renderText = renderText.substr(0, sizeIndex)
        }

        //check if it contains font
        let fontIndex = renderText.lastIndexOf(' @font:')
        if (fontIndex >= 0) {//we have font
            let fontContainer = renderText.substr(fontIndex + 1)
            var fontRegex = /@font:(.*)/i
            let fontMatch = fontContainer.match(fontRegex)
            if (fontMatch.length === 2) {
                font = fontMatch[1]
            }
            renderText = renderText.substr(0, fontIndex)
        }

        //create new texture
        if (this.textTexture === null) {
            this.textureCanvas = document.createElement('canvas')
            this.textureCanvas.style.display = 'none'
            document.body.appendChild(this.textureCanvas)
            this.textTexture = new THREE.Texture(this.textureCanvas)
        }

        let ctx = this.textTexture.image.getContext('2d')
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)

        let fontHeight = canvasHeigth
        let widthRatio = canvasWidthRatio
        let initials = renderText

        let width = fontHeight * widthRatio

        ctx.canvas.width = width
        ctx.canvas.height = fontHeight
        let fontInPixels = Math.ceil(300 * fontScale / 72)
        ctx.font = fontInPixels + 'px ' + font

        let span = document.createElement('span')
        span.innerText = 'M'
        span.style.fontFamily = font
        span.style.fontSize = fontInPixels + 'px'
        span.style.opacity = 0
        document.body.appendChild(span)
        let lineHeight = span.getBoundingClientRect().height
        document.body.removeChild(span)

        let left = 0
        let top = 0.5 * lineHeight + canvasHeigth * 0.5

        switch (position) {
            case 'left': {
                ctx.textAlign = 'left'
                left = 0
            }
                break;
            case 'center': {
                ctx.textAlign = 'center'
                left = width * 0.5
            }
                break;
            case 'right': {
                ctx.textAlign = 'right'
                left = width
            }
                break;
        }

        ctx.fillStyle = '#ffffff';
        ctx.fillText(initials, left, top)
        this.textTexture.needsUpdate = true
        return this.textTexture
    }
}
